export default __webpack_public_path__ + "static/media/1_3.4ce5d994.png";